/* global grecaptcha */
'use strict';

var floatingLabel = require('./floatingLabel');
var scrollAnimate = require('./scrollAnimate');

/**
 * Create an alert to display the error message
 * @param {Object} message - Error message to display
 * @param {Object} button - button that was clicked for email sign-up
 */
function createErrorNotification(message, button) {
    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error mt-3 ' +
        'fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        '</button>' + message + '</div>';

    button.closest('form').find('.recaptcha-error').append(errorHtml);
    scrollAnimate(button.closest('form'));
}

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for email sign-up
 */
function displayMessage(data, button) {
    $.spinner().stop();
    if (data.success) {
        $('#email-singup input.form-control').attr('aria-invalid', 'false');
        $('.subscribe-email').addClass('d-none');
        $('#email-singup').trigger('reset');
        $('.subscribe-response').removeClass('d-none').text(data.msg);
    } else if ('recaptchaErrorList' in data && data.recaptchaErrorList) {
        if (data.recaptchaErrorList && data.recaptchaErrorList.length) {
            $.each(data.recaptchaErrorList, function (index, element) {
                createErrorNotification(element, button);
            });
        }
    } else {
        if ($('.email-signup-error').length === 0) {
            $('#email-singup .form-inline').append(
                '<div class="email-signup-error"><i class="fa fa-exclamation-circle error-message-icon" aria-hidden="true"></i><span id="email-signup-error-msg" role="alert" class="email-signup-error-text"></span></div>'
             );
        }

        $('#email-singup input.form-control').addClass('is-invalid');
        $('#email-singup input.form-control').attr('aria-invalid', 'true');
        if (!$('.email-signup-error-text').text().length) {
            $('.email-signup-error-text').append(data.msg);
        }
    }
    $('input.form-control').focus(function () {
        $('.subscribe-email').removeClass('d-none');
        $('.subscribe-response').addClass('d-none');
    });
    setTimeout(function () {
        $('.email-signup-error').remove();
        $('#email-singup input.form-control').removeClass('is-invalid');
        button.removeAttr('disabled');
    }, 3000);
}

/**
 * Shared function to submit an ajax request to the form action URL and subsequently remove/append an alert with the response
 * @param {*} button form element to submit
 * @param {string} source form url.
 * @param {*} dataObj data to be sent via ajax request
 */
function submitSubscribeForm(button, source, dataObj) {
    $.spinner().start();
    button.attr('disabled', true);
    $.ajax({
        url: source,
        type: 'post',
        dataType: 'json',
        data: dataObj,
        success: function (data) {
            button.closest('form').find('.recaptcha-error').empty();
            displayMessage(data, button);
        },
        error: function (err) {
            button.closest('form').find('.recaptcha-error').empty();
            displayMessage(err, button);
        }
    });
}

module.exports = function () {
    $(document).ready(function () {
        if ($("input[name='isLoggedIn']") && $("input[name='isLoggedIn']").val() === 'true') {
            $('.trackorderlink').attr('href', $("input[name='historyPageURL']").val());
        }
    });

    $('.back-to-top').click(function () {
        scrollAnimate();
    });

    $('.subscribe-email').on('click', function (e) {
        e.preventDefault();
        var button = $(this);
        var form = $('form#email-singup');
        var formData = $(form).serialize();
        var url = $(form).attr('action');
        var siteKey = $('.recaptcha-subscribe').find('.custom-recaptcha-response').data('sitykey');
        var action = $('.recaptcha-subscribe').find('.custom-recaptcha-response').data('action');

        if (siteKey && siteKey !== '') {
            grecaptcha.ready(function () {
                grecaptcha.execute(siteKey, { action: action }).then(function (token) {
                    $('.recaptcha-subscribe').find('.custom-recaptcha-response').val(token);
                    formData = $(form).serialize();
                    submitSubscribeForm(button, url, formData);
                });
            });
        } else {
            submitSubscribeForm(button, url, formData);
        }
    });

    $(document).ready(function () {
        var observer = new MutationObserver(function () {
            var $onetrustBlocks = $('#onetrust-consent-sdk #onetrust-pc-sdk');
            if ($onetrustBlocks.length > 1) {
                $onetrustBlocks.slice(1).remove();
                observer.disconnect();
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    });
};

function scrollToSection() {
    // load the page with the the ID in the URL, it will jump to that section
    var pageUrl = window.location.href;
    if (pageUrl.includes('#')) {
        var pageId = pageUrl.substring(pageUrl.lastIndexOf('#') + 1);
        if ($('#' + pageId).length) {
            $(window).scrollTop(($('#' + pageId).offset().top) + 20);
        }

        if (new URL(location.href).searchParams.get('filterPanelOpen') === 'true') {
            if ($('.category-text-header__title').length || $('.category-text-header__description').length > 0) {
                $(window).scrollTop(($('#' + pageId).offset().top) - $('header').height() - 10);
            } else {
                $(window).scrollTop(($('#' + pageId).offset().top) - ($('header').height() - 50));
            }
        }
    }

    if ($(window).width() < 992) {
        $('.section-scrollpos').css('transform', 'translateY(' + -177 + 'px)');
    } else {
        $('.section-scrollpos').css('transform', 'translateY(' + -155 + 'px)');
    }
}

$(window).on('load', function () {
    floatingLabel.loadFloatingLabel();
    $('#PM-IPModal').modal('show');
    $('#PM-IPModal').appendTo('body');

    scrollToSection();
});

$(document).ready(function () {
    scrollToSection();
});
